import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e7dec8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pro-list"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompCard = _resolveComponent("CompCard");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createBlock(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": "— 我是有底线的 —",
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.proList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        onClick: $event => $options.goToInfo(item)
      }, [_createVNode(_component_CompCard, {
        item: item,
        index: index + 1
      }, null, 8, ["item", "index"])], 8, _hoisted_2);
    }), 128))])]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"]);
}